<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NGb8Qy/Images/Cover_0.jpg?1734367819047" alt="This image is the cover for the book In Plain Sight, A Wilson Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In Plain Sight, A Wilson Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>“Wilson is worthy to stand next to Loren Estleman’s Peter Macklin and Donald Westlake’s Parker” </b><b>(<i>Publishers Weekly</i>).</b><br/>  <br/> Wilson has tried to put his criminal past behind him—but now a random car accident has interfered with his plans and pushed him back in the crosshairs. Dirty cops have gotten their hooks in him and want to use him as bait, telling him the only way to stay out of cuffs is to put someone worse in them.<br/>  <br/> Knowing that justice isn’t blind in the city, Wilson picks a fight with the Russian mob to lure both the corrupt cops and brutal robbers into a trap, in a desperate attempt to scavenge his freedom again . . .<br/>  <br/> “A very good series.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Knowles
      </h2>
      
      <p class="authorDescription body article">Mike Knowles is an elementary school teacher and the author of Darwin's Nightmare and Grinder. He lives in Hamilton, Ontario.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ECW Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b14753d